import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'
// @ts-expect-error
import Sortable from 'sortablejs'

export default class extends Controller {
  static values = {
    url: String
  }

  declare urlValue: string

  sortable: Sortable

  connect (): void {
    this.sortable = Sortable.create(this.element, {
      group: 'shared',
      animation: 150,
      handle: '.sortable-handle',
      filter: '.ignore-elements',
      onEnd: this.end.bind(this)
    })
  }

  end (event: any): void {
    const id = event.item.dataset.id

    void patch(this.urlValue.replace(':id', id), {
      body: { position: parseInt(event.newIndex) + 1 }
    })
  }
}
